
import tunis from "./assets/statics/tunis.png"
import monastir from "./assets/statics/monastir.jpg"
import manar from "./assets/statics/manar.jpg"
import sfax from "./assets/statics/sfax.jpg"
import sousse from "./assets/statics/sousse.png"
import kairaouen from "./assets/statics/kairaouen.jpg"

const points = [
    { 
        link: "ipeit",
        name: "TUNIS" ,
        image: tunis
    }, {
        link: "ipeimo",
        name: "MONASTIR",
        image: monastir
    }, {
        link: "ipeim",
        name: "MANAR",
        image: manar
    },

    {
        link: "ipeis",
        name: "SFAX",
        image: sfax
    },
    {
        link: "enisso",
        name: "SOUSSE",
        image: sousse
    },
    {
        link: "ipeik",
        name: "KAIROUEN",
        image: kairaouen
    }
]
export default points;